import { OrgType, useAuthService } from "@/auth/AuthProvider";
import { Button } from "@/components/ui/button";
import { useQueryClient } from "@tanstack/react-query";
import { Building2, LucideIcon, Package } from "lucide-react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo from "@/assets/logo.svg";

export default function AccountSelector() {
  const navigate = useNavigate();

  const { authState, login } = useAuthService();
  const orgType = authState?.orgType;

  useEffect(() => {
    if (!orgType) return;
    const creditential = logins[orgType];
    login(creditential.email, creditential.password);
  }, []);

  const queryClient = useQueryClient();

  async function handleAccountChange(account: OrgType) {
    queryClient.clear();
    await queryClient.cancelQueries();

    const creditential = logins[account];

    console.log(creditential);
    await login(creditential.email, creditential.password);

    console.log("attempted to login");

    navigate(`/`);
  }

  return (
    <div className="flex items-center justify-between mb-1">
      <div className="flex items-center ps-1">
        <div className="flex items-center space-x-2">
          <div className="flex h-8 w-8 items-center justify-center rounded flex-shrink-0">
            {/* <Icon className="h-5 w-5 text-primary-foreground" /> */}
            <img src={logo} alt="Logo" className="" />
          </div>
          <span className="text-lg font-semibold whitespace-nowrap overflow-hidden mt-2">
            <span className="text-lupurple-dark">Freight</span> | Demo
          </span>
        </div>
      </div>
      <div className="flex space-x-2">
        {navigationItems.map((item) => {
          const Icon = item.icon;
          return (
            <Button
              key={item.id}
              variant={orgType === item.id ? "default" : "outline"}
              onClick={() => handleAccountChange(item.id)}
              className="flex items-center gap-2"
            >
              <Icon className="h-4 w-4" />
              {item.label}
            </Button>
          );
        })}
      </div>
    </div>
  );
}

const logins: Record<OrgType, { email: string; password: string }> = {
  Broker: {
    email: "broker@lu.app",
    password: "password",
  },
  Shipper: {
    email: "vendor@lu.app",
    password: "password",
  },
  Receiver: {
    email: "receiver@lu.app",
    password: "password",
  },
};

const navigationItems: { id: OrgType; label: string; icon: LucideIcon }[] = [
  { id: "Broker", label: "Broker", icon: Building2 },
  { id: "Shipper", label: "Shipper", icon: Package },
  {
    id: "Receiver",
    label: "Receiver",
    icon: Package,
  },
];
